import { makeAwsSignedRequest } from '../ApiService';

export interface TrackerAiTrackerData {
    created: number;
    approved: number;
    declined: number;
    pending: number;
    batched: number;
    unbatched: number;
    unstarted: number;
    withinSla: number;
    totalRefundsCreated: number;
    refundsPending: number;
    overSla: number;
    timeWindow: string;
    clientId?: string;
    metadata?: Record<string, unknown>;
}

export interface TrackerAiSummaryResponse {
    summary: string;
    signals: string[];
    recommendedActions: string[];
    caveats: string[];
    modelId?: string;
    generatedAt?: string;
}

export const AiInsightsService = {
    getTrackerSummary: (stage: string, realm: string, trackerData: TrackerAiTrackerData): Promise<TrackerAiSummaryResponse> =>
        makeAwsSignedRequest(stage, realm, 'ai/tracker-summary', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                stage,
                realm,
                trackerData,
            }),
            retry: false,
        }),
};
